import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE;
const FLASH_MS = 4500;

async function portalPost(path, body, token) {
  const { data } = await axios.post(`${API_BASE}${path}`, body, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

function pickFlash(data) {
  if (data?.message) return String(data.message);
  if (data?.ok) return "Equipped.";
  return "Done.";
}

export default function ProfilePortal({ profile, token, onPortalUpdate }) {
  const [busy, setBusy] = useState(null);
  const [flash, setFlash] = useState(null);

  useEffect(() => {
    if (!flash) return undefined;
    const t = setTimeout(() => setFlash(null), FLASH_MS);
    return () => clearTimeout(t);
  }, [flash]);

  if (!token || !profile) return null;

  const run = async (key, fn) => {
    setBusy(key);
    try {
      const data = await fn();
      if (data.portal) onPortalUpdate(data.portal);
      setFlash({ text: pickFlash(data), type: "ok" });
    } catch (err) {
      setFlash({
        text: err.response?.data?.error || "Something went wrong.",
        type: "err",
      });
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="portal-stack">
      {flash && (
        <div
          className={`portal-toast portal-toast-${flash.type}`}
          role="status"
          aria-live="polite"
        >
          <span>{flash.text}</span>
          <button
            type="button"
            className="portal-toast-dismiss"
            aria-label="Dismiss"
            onClick={() => setFlash(null)}
          >
            ×
          </button>
        </div>
      )}

      <p className="portal-muted">
        Daily, work, explore, meditate, and companion care live on the{" "}
        <strong>Overview</strong> tab.
      </p>

      <section className="portal-section">
        <h2>Titles</h2>
        <div className="portal-chip-row">
          {(profile.titles || []).map((t) => (
            <button
              key={t.title}
              type="button"
              className={`portal-chip${t.active ? " active" : ""}`}
              disabled={busy || t.active}
              onClick={() =>
                run(`title-${t.title}`, () =>
                  portalPost("/me/title", { title: t.title }, token),
                )
              }
            >
              {t.title}
            </button>
          ))}
        </div>
      </section>

      <section className="portal-section">
        <h2>Themes</h2>
        <div className="portal-chip-row">
          {(profile.themes || []).map((t) => (
            <button
              key={t.key}
              type="button"
              className={`portal-chip${t.active ? " active" : ""}`}
              disabled={busy || t.active}
              onClick={() =>
                run(`theme-${t.key}`, () =>
                  portalPost("/me/theme", { key: t.key }, token),
                )
              }
            >
              {t.emoji} {t.name}
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
